import routerOptions0 from "/home/runner/work/parmazip-pharmacist/parmazip-pharmacist/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@18.19.75_db0@0.2.3_ioredis@5.4.2_magicast_a00c80da332b6686e7655eb7793ce6a3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}